<template>
  <div class="tm-page-generator" :class="{ isMobile: mobileContentStyle }">
    <div
      class="tm-page-generator-background"
      :style="{ position: currentPreview ? 'absolute' : 'fixed' }"
    ></div>
    <div
      class="tm-page-generator-content"
      v-for="(item, index) in formList"
      :key="item.id"
    >
      <div class="tm-page-generator-header">
        <p v-if="currentPreview">
          你好，<span class="uid">123456</span>；<span class="logout"
            >安全退出</span
          >
        </p>
        <template v-else>
          <p v-if="userId">
            你好，<span class="uid">{{ userId }}</span
            >；<span class="logout" @click="logout">安全退出</span>
          </p>
          <p v-else>
            <span class="logout">你好，请先登录</span>
          </p>
        </template>
      </div>
      <div class="tm-page-generator-form">
        <div class="tm-page-generator-form-header"></div>
        <div v-if="!successShow" class="tm-page-generator-form-title">
          <div v-html="item.attributes.title"></div>
        </div>
        <div v-if="!successShow" class="tm-page-generator-form-content">
          <FormGenerator
            class="tm-page-generator-form-content-main"
            :formConfig="item.items"
            :labelPosition="item.attributes.labelPosition"
            :labelWidth="item.attributes.labelWidth"
            @form-submit="handleSubmit"
          />
          <div class="tm-page-generator-form-content-footer">
            <div class="tm-page-generator-form-content-footer-logo"></div>
          </div>
        </div>
        <Success v-else :isRepeatSubmit="isRepeatSubmit" />
      </div>
    </div>
    <Dialog
      v-if="dialogShow"
      :content="dialogContent"
      @close="dialogShow = false"
    ></Dialog>
  </div>
</template>

<script>
import "@/assets/css/index.css";
import "@taomee/form-generator/dist/form-generator.css";
import { FormGenerator } from "@taomee/form-generator";
import ApiClient from "@/utils/api";
import { initRemAdapter } from "@/utils/remAdapter";
import Dialog from "./Dialog.vue";
import Success from "./success.vue";
export default {
  name: "tm-page",
  components: {
    FormGenerator,
    Dialog,
    Success,
  },
  props: {
    pageConfig: {
      type: Object,
      default: () => {},
    },
    env: {
      type: String,
      default: "dev",
    },
    isMobile: {
      type: [Boolean, String],
      default: false,
    },
    isPreview: {
      type: [Boolean, String],
      default: false,
    },
    // 是否支持重复提交
    isRepeatSubmit: {
      type: [Boolean, String, Number],
      default: 0,
    },
    // 问卷id
    id: {
      type: String,
      default: "",
    },
    // 用户来源
    userFrom:{
      type: String,
      default: "",
    }
  },
  computed: {
    formList() {
      if (Object.keys(this.pageConfig).length === 0) {
        return [];
      }
      this.pageConfig.items.forEach((item) => {
        item.items.push({
          id: Math.random().toString(36).substring(2, 15),
          component: "tm-button",
          attributes: {
            label: "提交",
            type: "submit",
            requestId: "save",
          },
        });
        item["dataSet"] = [
          {
            id: "save",
            request: {
              url: "/save",
            },
          },
        ];
      });
      const data = this.pageConfig.items;
      let finalData = data;
      if (this.env === "prod") {
        finalData = JSON.parse(
          JSON.stringify(data).replaceAll(
            "admin-webevent-test.61.com/resource",
            "webres.61.com/dynamic"
          )
        );
      }
      return finalData;
    },
    currentPreview() {
      return JSON.parse(this.isPreview);
    },
    mobileContentStyle() {
      return this.isMobile == true ? true : false;
    },
  },
  created() {
    this.loadSDK();
  },
  mounted() {
    // 初始化 rem 适配（基于父元素）
    this.initRemAdapter();

    if (Object.keys(this.pageConfig).length > 0 && !this.currentPreview) {
      this.initSDK();
      this.instance = new ApiClient(this.env);
      this.report();
    }
    // 获取浏览器信息和操作系统
    this.platform = navigator.platform;
    this.userAgent = navigator.userAgent;
  },
  beforeDestroy() {
    // 清理 rem 适配器
    if (this.remAdapter) {
      this.remAdapter.destroy();
      this.remAdapter = null;
    }
  },

  data() {
    return {
      dialogShow: false,
      dialogContent: "",
      productFormData: {},
      sdk: null,
      sdkLoaded: false,
      userId: null, // 新增userId属性，确保其响应式
      successShow: false,
      remAdapter: null, // rem 适配器实例
      answerTime: null, // 新增answerTime属性
      platform: null,
      userAgent: null, 
    };
  },
  methods: {
    // 统计
    report() {
      this.instance.get("writeBrowseLog&id=" + this.id);
    },
    initRemAdapter() {
      this.$nextTick(() => {
        // 获取父元素（容器），如果没有父元素则使用组件根元素
        const containerElement = this.$el.parentElement || this.$el;

        // 初始化 rem 适配器
        this.remAdapter = initRemAdapter(containerElement, {
          remBase: 25, // 桌面端 rem 基准值
          remBaseMobile: 7.5, // 移动端 rem 基准值
          breakpoint: 900, // 移动端断点
          defaultWidth: 2560, // 默认宽度
        });
      });
    },
    loadSDK() {
      var head = document.getElementsByTagName("head")[0];
      let sdkCssUrl =
        "https://account-co-inner.61.com/sdk/css/taomeesdk.1.1.1.css";
      let sdkJsUrl =
        "https://account-co-inner.61.com/sdk/js/taomeesdk.1.1.1.js";
      if (this.env === "pre" || this.env === "prod") {
        sdkCssUrl = "//opensdk.61.com/v1/css/taomeesdk.1.1.1.css";
        sdkJsUrl = "//opensdk.61.com/v1/js/taomeesdk.1.1.1.js";
      }

      if (sdkCssUrl) {
        var cssLink = document.createElement("link");
        cssLink.href = sdkCssUrl + "?" + new Date().getTime();
        cssLink.rel = "stylesheet";
        head.appendChild(cssLink);
      } else {
        console.warn("未配置 SDK CSS 地址（sdkCssUrl）");
      }
      if (sdkJsUrl) {
        var script = document.createElement("script");
        script.src = sdkJsUrl + "?" + new Date().getTime();
        script.type = "text/javascript";
        head.appendChild(script);
      } else {
        console.warn("未配置 SDK JS 地址（sdkJsUrl）");
      }
    },
    async handleSubmit(data) {
      if (this.currentPreview) {
        this.$emit("preview-submit");
        return;
      }
      const params = {
        id: this.pageConfig.id,
        data: data.formData,
        os: this.platform,
        browser: this.userAgent,
        answerTime: this.answerTime,
        userFrom: this.userFrom,
      };
      // 暂时处理一个表单的dataset
      if (this.pageConfig.items[0].dataSet.length > 0) {
        const url = this.pageConfig.items[0].dataSet.find(
          (item) => item.id === data.requestId
        ).request.url;
        try {
          await this.instance.post(url, params);
          this.goSuccess();
        } catch (error) {
          this.dialogShow = true;
          this.dialogContent = error;
        }
      }
    },
    initSDK() {
      if (!window.TaomeeSDK) {
        setTimeout(() => {
          this.initSDK();
        }, 50);
        return;
      }
      this.sdk = new window.TaomeeSDK({
        appId: "202603111234",
        kickoff: function () {},
        loginCallback: (result) => {
          if (result.type === "cancel") {
            this.initSDK();
            return;
          }
          if (result.type === "success") {
            this.report();
            this.getTime();
            this.instance
              .get("loginDc&uid=" + result.uid + "&token=" + result.token)
              .then((data) => {
                this.userId = data.dcUid;
                this.getUserInfo();
              })
              .catch((error) => {
                this.dialogShow = true;
                this.dialogContent = error;
              });
          }
        },
      });

      this.checkIsLogin();
    },
    checkIsLogin() {
      this.sdk.checkIsLogin("checkIsLogin", (result) => {
        const isLogin = result.type === "success";
        if (isLogin) {
          // sdk是登陆态，也要通知后台
          this.report();
          this.getTime();
          this.instance
          .get("loginDc&uid=" + result.uid + "&token=" + result.token)
          .then((data) => {
            this.userId = data.dcUid;
            this.getUserInfo();
          })
          .catch((error) => {
            this.sdk.login();
          });
        } else {
          this.sdk.login();
        }
      });
    },
    // 获取时间
    async getTime() {
      const data = await this.instance.get("getNow");
      this.answerTime = data;
    },
    async getUserInfo() {
      try {
        if(this.isRepeatSubmit === 1) {
          return;
        }
        const data = await this.instance.get(
          "getUserInfo&id=" + this.pageConfig.id
        );
        if (data === 1) {
          this.goSuccess();
        }
      } catch (error) {
        this.dialogShow = true;
        this.dialogContent = error;
      }
    },
    goSuccess() {
      this.successShow = true;
    },
    logout() {
      this.sdk.logout();
      window.location.href = window.location.protocol + '//' + window.location.host+'/?id='+this.id;
    },
  },
};
</script>

<style scoped>
.tm-page-generator-background {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  background-size: cover;
  background-position: top center;
  background-repeat: no-repeat;
  background-image: url(../assets/images/bg.jpg);
  color: #333;
  pointer-events: none;
  /* 只控制背景，实际内容放 tm-page-generator，滚动页面时背景不动 */
}
.tm-page-generator {
  position: relative;
  z-index: 1;
  width: 100%;
  /* 内容区域不定高，超出可滚动 */
  /* 修改：页面内容滚动 */
  min-height: 100vh;
  box-sizing: border-box;
}
.tm-page-generator-content {
  width: 900px;
  margin: 0 auto;
  padding-top: 45px;
  box-sizing: border-box;
  position: relative;
  z-index: 1;
  background: transparent;
}

.tm-page-generator-header {
  font-size: 18px;
  text-align: right;
  margin-bottom: 20px;
  padding-right: 10px;
  box-sizing: border-box;
  color: #999999;
  font-family: "Microsoft YaHei", sans-serif;
}

.uid {
  color: #ff7443;
}

.logout {
  cursor: pointer;
}

.tm-page-generator-form {
  display: flex;
  flex-direction: column;
  flex: 1;
  background-color: #fff;
  border-radius: 10px 10px 0 0;
  box-shadow: 0 0 10px 0 rgba(187, 187, 187, 0.29);
}
.tm-page-generator-form-header {
  width: 100%;
  height: 121px;
  overflow: hidden;
  margin-bottom: 55px;
  background: url(../assets/images/header.jpg) no-repeat center center;
  background-size: 100% auto;
}

.tm-page-generator-form-title {
  width: 100%;
  padding: 0 50px;
  margin-bottom: 30px;
  font-size: 30px;
  font-weight: bold;
  text-align: center;
  box-sizing: border-box;
}

.tm-page-generator-form-title div {
  width: 100%;
  height: 100%;
  padding-bottom: 30px;
  box-sizing: border-box;
  border-bottom: 1px solid #e6e6e6;
}
.tm-page-generator-form-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  font-size: 16px !important;
  overflow: auto;
}

.tm-page-generator-form-content::-webkit-scrollbar {
  width: 100%;
}
.tm-page-generator-form-content-main {
  flex: 1;
  /* padding-left: 10px; */
  box-sizing: border-box;
  font-family: "AlibabaPuHuiTi", "Microsoft YaHei", sans-serif;
}
.tm-page-generator-form-content-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 75px;
  background-color: #f0f0f0;
}

.tm-page-generator-form-content-footer-logo {
  width: 168px;
  height: 27px;
  background: url("https://webres.61.com/common/images/taomee.png") no-repeat
    center center;
  background-size: 100% auto;
}

.isMobile .tm-page-generator-content {
  width: 100%;
  height: auto;
}
@media screen and (max-width: 900px) {
  .tm-page-generator-content {
    width: 100%;
    height: auto;
  }
  :deep(.tm-form-container) {
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 auto;
    padding: 0 30px!important;
    box-sizing: border-box;
  }
}
</style>
<style scoped>
:deep(.tm-form-container) {
  width: 770px;
  max-width: 770px;
  margin: 0 auto;
  padding: 0;
}

:deep(.tm-form-item) {
  margin-bottom: 10px !important;
  font-size: 16px !important;
  padding: 0 25px 25px;
  box-sizing: border-box;
}
:deep(.tm-form-item-error) {
  padding-top: 8px;
  border: 1px dashed #ff4000;
}

:deep(.tm-form-item:last-child) {
  border: none;
}

:deep(.tm-form-item:last-child .tm-form-item-content) {
  width: 100%;
}

:deep(.tm-label) {
  width: 100% !important;
  font-size: 22px;
  font-weight: bold;
  line-height: 48px !important;
  margin-bottom: 0 !important;
}
:deep(.tm-form-item-extra) {
  color: #fdb26e;
  margin-bottom: 15px;
}
:deep(.tm-form-item-content) {
  width: 500px;
}

:deep(.tm-form-item-content input) {
  font-size: 16px;
}

:deep(.tm-form-item-content input::placeholder) {
  font-size: 16px;
}

:deep(.tm-form-item-content-component) {
  height: 45px;
  line-height: 45px;
  border-radius: 0;
}
:deep(.tm-form-item-content-component.tm-radio),
:deep(.tm-form-item-content-component.tm-checkbox) {
  height: auto;
  line-height: 30px;
}
:deep(.tm-form-item-content-component:focus) {
  border: 1px solid #ff7443;
  box-shadow: 0 0 10px 0 rgba(255, 116, 67, 0.29);
}

/* select */
:deep(.tm-form-item-content-component.tm-custom-select:focus) {
  border: none;
  box-shadow: none;
}

/* select */
:deep(.tm-custom-select .tm-custom-select__selected) {
  border-radius: 0;
  height: 100%;
}

:deep(.tm-custom-select.open .tm-custom-select__selected) {
  border: 1px solid #ff7443;
  box-shadow: 0 0 10px 0 rgba(255, 116, 67, 0.29);
}

:deep(.tm-custom-select__dropdown li.selected) {
  color: #fdb26e;
}

/* radio 和 checkbox*/
:deep(.tm-radio-custom.checked),
:deep(.tm-checkbox-label .tm-checkbox-input:checked + .tm-checkbox-custom) {
  border-color: #fdb26e;
}
:deep(.dct-fonts-checkbox),
:deep(.dct-fonts-radio) {
  color: #fdb26e;
}

:deep(.tm-checkbox-custom) {
  width: 17px;
  height: 17px;
  border-radius: 0;
  border-width: 1px;
}

:deep(.tm-radio-custom) {
  border-width: 1px;
}

/* 提交按钮 */
:deep(.tm-form-button) {
  width: 176px;
  height: 52px;
  line-height: 52px;
  font-size: 22px;
  letter-spacing: 5px;
  color: #fff;
  background: linear-gradient(90deg, #ffa054 0%, #ff7730 100%);
  border-radius: 50px;
}

/* 错误提示 */
:deep(.tm-form-item-content .error-message) {
  position: relative;
  width: 720px;
  height: 40px;
  line-height: 40px;
  text-align: left;
  background-color: #ffecec;
  color: #333;
  padding-left: 10px;
  box-sizing: border-box;
  margin-top: 20px;
}
:deep(.dct-fonts-close) {
  color: #fb6431;
}
</style>
